import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import UIFlex from 'UIComponents/layout/UIFlex';
import ClearFiltersButton from './ClearFiltersButton';
import FiltersAppliedText from './FiltersAppliedText';
import FiltersButton from './FiltersButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FiltersBar(props) {
  const filters = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    direction: "row",
    justify: "start",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx(FiltersButton, {
      "data-test-id": "filters-bar-filters-button",
      onClick: props.onFiltersClick
    }), !filters.isEmpty() ? /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "row",
      justify: "end",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx("span", {
        className: "m-right-2",
        children: /*#__PURE__*/_jsx(FiltersAppliedText, {
          "data-test-id": "filters-bar-filters-applied-text"
        })
      }), /*#__PURE__*/_jsx(ClearFiltersButton, {
        "data-test-id": "filters-bar-clear-filters-button"
      })]
    }) : null]
  });
}
FiltersBar.propTypes = {
  onFiltersClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(FiltersBar);